// extracted by mini-css-extract-plugin
export default {"rewardScalabilityFormIterator":"manageCampaign_rewardScalabilityFormIterator__N4aS+"};